module.exports = __webpack_public_path__ + "img/logodx.cd5fbe96.png";